import React from 'react'
import sharedCS from "./SharedCS.module.css";
function SharedCS(props) {
  return (
    <div className={sharedCS.Header}>
      <div className={sharedCS.Subheading}>{props.Title}</div>
      <div className={sharedCS.Icon}>
        {props.Icon} 
      </div>
    </div>
  )
}

export default SharedCS